/**
 * DEV-2684 — /ben (kullanıcı özeti) isteğine dair iki ortak kural; bağımlılıksız tutulur (StatusCodeHelper,
 * store ve eklentiler ithal zinciri büyütmeden kullanır).
 */

// Yalnız `/api/v1/ben` ucunun kendisi; `/api/v1/ben/...` alt yolları ve `/api/v1/benzer` gibi uçlar değil.
const BEN_ISTEGI = /\/api\/v1\/ben(?:[?#]|$)/;

/** İstek adresi /ben'in kendisi mi (göreli ya da mutlak; sorgu/çapa dahil). */
export function benIstegiMi(url: unknown): boolean {
    return typeof url === "string" && BEN_ISTEGI.test(url);
}

// /ben iki ayrı tek-uçuş kilidinden (store `ozellikDurumunuTazele`, `benTazele`) eşzamanlı çekilebilir; yanıtlar
// sırasız dönerse önce başlamış (bayat) yanıt, sonra başlamışın yazdığı kullanıcıyı geri almasın.
let sonBaslayan = 0;
let sonYazilan = 0;

/** Kullanıcıya yazılacak bir /ben isteği başlarken çağrılır; isteğin sıra numarasını verir. */
export function benIstegiBaslat(): number {
    return ++sonBaslayan;
}

/** Yanıt kullanıcıya yazılabilir mi: daha sonra başlamış bir yanıt zaten yazıldıysa hayır. Evetse sıra işlenir. */
export function benYanitiYazilsinMi(no: number): boolean {
    if (no < sonYazilan) {
        return false;
    }
    sonYazilan = no;
    return true;
}
